import Image from "next/image";
import React from "react";
import { FeatureInfo } from "./UnknownNavBar";

const MobileNavContent = (props: { item: FeatureInfo }) => {
    return (
        <div className="flex">
            <a href={props.item.link} className="hover:no-underline">
                <div className="flex items-start gap-4 cursor-pointer">
                    {props.item.image && <Image width={props.item.width ?? 32} height={props.item.height ?? 32} src={props.item.image} alt={props.item.imgAlt ?? ""} />}
                    <div className="font-semibold text-base flex flex-col pb-2">
                        {props.item.title && <p className="method-content"> {props.item.title}</p>}
                        <p className="text-sm font-normal py-1">{props.item.summary}</p>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default React.memo(MobileNavContent);
